import { Col, Tab, Nav } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import PageContainer from '../PageContainer';
import Header from '../Header';
import Footer from '../Footer';
import MFAView from './MFAView';
import ChangePassword from './ChangePassword';
import Subscriptions from './Subscriptions';
import Form from '../form/Form';
import { useSelector } from 'react-redux';
import '../../styles/profile.scss';

const getLogoLayout = ({ avatar }) => {
  return [
    {
      name: 'userLogo',
      type: 'file',
      maxListSize: 1,
      col: {
        sm: 8,
        md: 6,
        lg: 4,
      },
      style: 'square',
      finalPath: 'cloud',
      data: avatar,
    },
  ];
};

const ProfileView = ({ view = 'avatar', avatar, handleSetLogo, ...rest }) => {
  const history = useHistory();
  const config = useSelector(state => state.app.config);

  const handleTabChange = eventKey => {
    if (eventKey) {
      history.replace(`/profile/${eventKey}`);
    }
  };

  return (
    <PageContainer id="profile-container">
      <Header title="Profile" />
      <div className="form-edit-container">
        <Tab.Container id="page-tabs" defaultActiveKey={view} onSelect={handleTabChange}>
          <div className="clearfix">
            <div className="tab-labels">
              <Nav variant="tabs">
                <Nav.Item key="avatar">
                  <Nav.Link eventKey="avatar">Avatar</Nav.Link>
                </Nav.Item>
                {!config.features.disablePasswordReset && (
                  <Nav.Item key="password">
                    <Nav.Link eventKey="password">Change Password</Nav.Link>
                  </Nav.Item>
                )}
                <Nav.Item key="mfa">
                  <Nav.Link eventKey="mfa">Multi-Factor Authentication</Nav.Link>
                </Nav.Item>
                <Nav.Item key="subs">
                  <Nav.Link eventKey="subs">Subscriptions</Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            <Tab.Content>
              <Tab.Pane key="avatar" eventKey="avatar">
                <Col>
                  <Form
                    layout={getLogoLayout({ avatar })}
                    submit={handleSetLogo}
                    submitLabel="Update Avatar"
                    exportFormat="object"
                    hideCancel
                  />
                </Col>
              </Tab.Pane>
              <Tab.Pane key="password" eventKey="password">
                <Col lg={4} md={6} sm={6}>
                  {!config.features.disablePasswordReset && <ChangePassword {...rest} />}
                </Col>
              </Tab.Pane>
              <Tab.Pane key="mfa" eventKey="mfa">
                <Col>
                  <MFAView />
                </Col>
              </Tab.Pane>
              <Tab.Pane key="subs" eventKey="subs">
                <Col>
                  <Subscriptions />
                </Col>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
      <Footer />
    </PageContainer>
  );
};

ProfileView.propTypes = {
  avatar: PropTypes.string,
  password: PropTypes.string,
  repeatPassword: PropTypes.string,
  handleSubmitPassword: PropTypes.func,
  handlePasswordChange: PropTypes.func,
  handlePasswordRepeatChange: PropTypes.func,
  handleSetLogo: PropTypes.func,
  view: PropTypes.string,
};

export default ProfileView;
